export const MODAL_NAME = 'ListingsImportExportDrawer'

export const FORM_TYPES = {
  UPDATE: 'update',
  IMPORT: 'import',
  IMPORT_NEW: 'import-new',
  EXPORT: 'export',
}

export const HASH_NAME = 'listing-action'

export const ENCODING_OPTIONS = [
  { value: 'utf-8', label: 'UTF-8' },
  { value: 'latin1', label: 'Latin-1 (CP-1252)' },
]
